import { render } from "./InputComponent.vue?vue&type=template&id=2f07208a"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__